var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',{staticClass:"page-holder"},[_c('logo',{staticClass:"hide-on-mobile"})],1)]),_c('div',{staticClass:"booking-body"},[_c('p',[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.redirect('/')}}},[_vm._v("Home")])]),_c('beBookingForm')],1),_c('MyFooter',{attrs:{"property":'redirect'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }